<div class="container h-full flex flex-col mx-auto px-4 md:px-6 pt-8 pb-4">
  <div class="flex items-center mb-4 min-h-10">
    <h2 class="text-2xl font-medium">Cliënten</h2>
    <button
      *appHasPermission="'client:create'"
      mat-button
      class="ml-auto"
      (click)="addClient()"
    >
      <mat-icon>add</mat-icon>

      Nieuwe cliënt
    </button>
  </div>

  <div class="bg-white p-4 rounded-t-lg">
    <mat-form-field
      subscriptSizing="dynamic"
      class="w-full [--mat-form-field-container-text-size:14px] [--mat-form-field-container-height:48px] [--mat-form-field-container-vertical-padding:12px]"
    >
      <mat-icon matPrefix> search </mat-icon>

      <input
        #searchInput
        matInput
        placeholder="Zoeken op ID of naam..."
        [disabled]="isSearchDisabled()"
        [ngModel]="keyword()"
        (ngModelChange)="handleSearch(searchInput.value)"
      />

      @if (keyword()) {
        <button mat-icon-button matSuffix class="mr-1" (click)="clearSearch()">
          <mat-icon>cancel</mat-icon>
        </button>
      }
    </mat-form-field>
  </div>

  <app-data-table-container class="rounded-b-lg!">
    <table
      mat-table
      matSort
      matSortDirection="asc"
      matSortActive="name"
      matSortDisableClear
      [matSortDisabled]="hasNoData()"
      (matSortChange)="handleSortChange($event)"
      [dataSource]="dataSource()"
    >
      <ng-container matColumnDef="idAlias" sticky>
        <th mat-header-cell *matHeaderCellDef># Client ID</th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.deleteAt || element.moveId">
          {{ element.idAlias }}
        </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>Naam</th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.deleteAt || element.moveId">
          <span
            class="w-min max-w-40 truncate block"
            [matTooltip]="element.name"
            matTooltipPosition="after"
            >{{ element.name }}</span
          >
          @if (element.moveId) {
            <span class="text-xs text-orange-500 font-medium">Wordt verplaatst...</span>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="createdAt">
        <th mat-header-cell mat-sort-header="created_at" *matHeaderCellDef>
          Aangemaakt op
        </th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.deleteAt || element.moveId">
          {{ element.createdAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="attachedTo">
        <th mat-header-cell *matHeaderCellDef>Gekoppeld aan</th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.deleteAt">
          @if (element.robot; as robot) {
            <div class="inline-flex items-center gap-1">
              <span
                class="w-min max-w-40 truncate block"
                [matTooltip]="robot.name"
                matTooltipPosition="after"
                >{{ robot.name }}</span
              >
              <a href="" class="text-xs font-medium text-blue-500 hover:underline">{{
                '#' + robot.idAlias
              }}</a>
            </div>
          } @else {
            -
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell mat-sort-header="updated_at" *matHeaderCellDef>
          Laatst bewerkt op
        </th>
        <td mat-cell *matCellDef="let element" [class.opacity-50]="element.deleteAt || element.moveId">
          {{ element.updatedAt | date: 'MMMM dd, yyyy HH:mm' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          @if (element.deleteAt) {
            <div>
              <button
                *appHasPermission="'client:update'"
                mat-icon-button
                matTooltip="Cliënt herstellen"
                (click)="restoreClient(element)"
              >
                <mat-icon>restore_from_trash</mat-icon>
              </button>
            </div>
          } @else if (element.moveId) {
            <div>
              <span class="text-xs text-gray-400">Vergrendeld</span>
            </div>
          } @else {
            <div>
              <button
                mat-icon-button
                matTooltip="Statistieken"
                (click)="router.navigate(['clients', element._id, 'overview'])"
              >
                <mat-icon>show_chart</mat-icon>
              </button>
              <button
                *appHasPermission="'scm:read'"
                mat-icon-button
                matTooltip="Signalering"
                (click)="router.navigate(['clients', element._id, 'signaling'])"
              >
                <mat-icon>leak_add</mat-icon>
              </button>
              <button
                mat-icon-button
                matTooltip="Historie"
                (click)="router.navigate(['clients', element._id, 'history'])"
              >
                <mat-icon>history</mat-icon>
              </button>
              <button
                *appHasPermission="'client_event:read'"
                mat-icon-button
                matTooltip="Planning"
                (click)="router.navigate(['clients', element._id, 'scheduler'])"
              >
                <mat-icon>today</mat-icon>
              </button>
              <button
                *appHasPermission="['client:update', 'client:delete', 'client:move']"
                mat-icon-button
                [matMenuTriggerFor]="menu"
                matTooltip="Meer"
              >
                <mat-icon>more_vert</mat-icon>
              </button>
            </div>

            <mat-menu #menu="matMenu">
              <button
                *appHasPermission="'client:update'"
                mat-menu-item
                (click)="router.navigate(['clients', element._id, 'settings'])"
              >
                Bewerken
              </button>

              <button
                *appHasPermission="'client:move'"
                mat-menu-item
                (click)="moveClient(element)"
              >
                Verplaatsen
              </button>

              <button
                *appHasPermission="'client:delete'"
                mat-menu-item
                (click)="deleteClient(element)"
              >
                Verwijderen
              </button>
            </mat-menu>
          }
        </td>
      </ng-container>

      <tr
        mat-header-row
        *matHeaderRowDef="displayedColumns; sticky: true"
        class="whitespace-nowrap"
      ></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: displayedColumns"
        class="whitespace-nowrap hover:!bg-gray-100"
        (dblclick)="onRowDblClick(row)"
      ></tr>

      <tr class="mat-mdc-row" *matNoDataRow>
        <td
          class="mat-mdc-cell mdc-data-table__cell !border-none"
          [colSpan]="displayedColumns.length"
        >
          Geen resultaten gevonden
        </td>
      </tr>
    </table>

    <mat-paginator
      class="border-t border-(--mat-table-row-item-outline-color)"
      (page)="handlePageChange($event)"
      [pageSize]="pageSize()"
      [pageSizeOptions]="[25, 50, 100]"
    ></mat-paginator>
  </app-data-table-container>
</div>
